import { render, staticRenderFns } from "./ActivityLiveClass.vue?vue&type=template&id=4bf02dc8&"
import script from "./ActivityLiveClass.vue?vue&type=script&lang=js&"
export * from "./ActivityLiveClass.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLiveClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActivityLiveClass.vue"
export default component.exports